﻿import { flattenMilestones } from "@/helpers";
import { IMilestoneTemplate } from "@/interfaces";
import { useEffect, useState } from "react";

export const useMilestoneRadioProperty = (
  milestoneTemplates: IMilestoneTemplate[],
  property: keyof IMilestoneTemplate
): string | undefined => {
  const [milestoneId, setMilestoneId] = useState<string | undefined>();

  useEffect(() => {
    const milestone = flattenMilestones(milestoneTemplates).find(
      (milestone) => milestone[property]
    );

    setMilestoneId(milestone?.id);
  }, [milestoneTemplates, property]);

  return milestoneId;
};
